<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="PersonDetails.saveError">
    <template slot="center">
      <el-form
        :model="formData"
        :rules="rules"
        :label-position="labelPosition"
        :ref="formRef"
        label-width="20em">

        <section>
          <div class="section_items">
            <el-form-item prop="confirmDelete" :label="$t('label.delete')">
              <el-checkbox v-model="formData.confirmDelete" :disabled="!edit">{{ $t('label.confirm_action') }}</el-checkbox>
              <p class="el-form-item__help">{{ $t('label.confirm_delete_help') }}</p>
            </el-form-item>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <el-button
           type="danger"
           size="small"
          :disabled="!formData.confirmDelete"
          @click="handleDelete">
            {{ $t('label.delete') }}
        </el-button>
        <el-button
           type="text"
           size="small"
          @click="cancelChanges">
          {{ $t('label.cancel') }}
        </el-button>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-stuff-to-eat-delete',
  mixins: [FormStandardBehavior],
  props: {
    id: {
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    PersonDetails: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        confirmDelete: false,
      },
      rules: {
        confirmDelete: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.confirm_delete', true),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    gerFormData() {
      return this.formData;
    },
  },
  created() {
    this.stateData = this.PersonDetails;
    this.formRef = 'form-stuff-to-eat-delete';
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/shared/delete/form-person-delete.vue